import type { PaperLine } from "../types";

export type LineGroup =
  | { type: "table"; lines: PaperLine[] }
  | { type: "single"; line: PaperLine };

const isTableRow = (text: string): boolean => /^\|.*\|$/.test(text.trim());

export const hasEmbeddedTable = (text: string): boolean => {
  if (!text.includes("\n") || !text.includes("|")) return false;
  const rows = text.split("\n").filter((r) => r.trim().length > 0);
  return rows.length >= 2 && rows.every((r) => isTableRow(r));
};

export const groupTableLines = (lines: PaperLine[]): LineGroup[] => {
  const groups: LineGroup[] = [];
  let i = 0;

  while (i < lines.length) {
    if (isTableRow(lines[i].text)) {
      const tableLines: PaperLine[] = [];
      while (i < lines.length && isTableRow(lines[i].text)) {
        tableLines.push(lines[i]);
        i++;
      }
      groups.push({ type: "table", lines: tableLines });
    } else {
      groups.push({ type: "single", line: lines[i] });
      i++;
    }
  }

  return groups;
};
